import { render, staticRenderFns } from "./NewGroupStepThree.vue?vue&type=template&id=f95e4e50"
import script from "./NewGroupStepThree.vue?vue&type=script&lang=js"
export * from "./NewGroupStepThree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports